import { Injectable } from '@angular/core';
import { InAppReview } from '@capacitor-community/in-app-review';
import { Capacitor } from '@capacitor/core';
import { GlobalDataService } from './global-data.service'; // Adjust the import path as necessary

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  constructor(private globalData: GlobalDataService) { }

  async requestReview(callback: () => void): Promise<void> {
    const platform = Capacitor.getPlatform();
    if ((platform === 'ios' && (this.globalData.showAppRatingIos === "true" || this.globalData.showAppRatingIos)) ||
      (platform === 'android' && (this.globalData.showAppRatingAndroid === "true" || this.globalData.showAppRatingAndroid))) {

      try {
        await InAppReview.requestReview();
      } catch (error) {
      }
    }
    callback();
  }
}
